
export default {
  name: 'TableRow',
  props: {
    satisfies: Boolean,
    nosatisfies: Boolean,
    title: {
      type: String,
      default: 'true',
    },
    type: {
      type: String,
      default: '',
    },
    dataList: {
      type: Array,
      default: Array,
    },
    // 容器追加的样式覆盖默认样式
    className: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      stripe: ['odd', 'even'],
      bingo_src: require('~/assets/image/price/bingo.png'),
    }
  },
}
